import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ICustomerCircuit } from "../../interfaces/customerCircuid";
import { EPackageType } from "../../interfaces/packageType";
import { getCircuitsByUserID } from "../../store/actions/dashborad.action";
import { IRootState } from "../../store/configureStore";
import SearchBar from "../searchBar/SearchBar";
import SelectOption, { ISelectOption } from "../selectOption/SelectOption";

interface IProps {
  selectedPackageType: EPackageType | [];
  selectedCircuitId: ISelectOption | [];
  handleChangeCircuitId: (value: ISelectOption | []) => void;
  setSelectedPackageType: (
    type: EPackageType
  ) => void | React.Dispatch<React.SetStateAction<EPackageType | []>>;
  className?: string;
  onChangeBroadbandId?: (id: string) => void;
  onSearchInBroadbandId?: (id: string) => void;
  shouldShowSearchIcon?: boolean;
  isWithBroadband?: boolean;
  defaultPackageType?: EPackageType | [];
  defaultBroadbandId?: string;
}

const ProductAndCircuitIdSelector = (props: IProps) => {
  const dispatch: any = useDispatch();
  const {
    selectedPackageType,
    selectedCircuitId,
    handleChangeCircuitId,
    setSelectedPackageType,
    className,
    defaultPackageType,
    shouldShowSearchIcon = true,
    isWithBroadband = true,
    defaultBroadbandId,
  } = props;
  const [circuitIdOptions, setCircuitIdOptions] = useState<ISelectOption[]>([]);

  const { packageTypes, circuits, userId } = useSelector(
    ({ dashboard, privileges }: IRootState) => ({
      packageTypes: dashboard.packageTypes,
      circuits: dashboard.circuits,
      userId: privileges.dataBundleUser?.id,
    })
  );

  useEffect(() => {
    if (userId) {
      dispatch(getCircuitsByUserID(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    setCircuitIdOptions(
      circuits
        .filter((circuit) => circuit.packageType === selectedPackageType)
        .map((circuit: ICustomerCircuit) => ({
          label: `${circuit.circuitId} - ${circuit.customer.name}`,
          value: circuit.circuitId,
        }))
    );
  }, [selectedPackageType, circuits]);

  const getPackageTypesOptions = (): ISelectOption[] => {
    const packageTypesOptions: ISelectOption[] = packageTypes.map((type) => ({
      label: type,
      value: type,
    }));

    if (isWithBroadband) {
      packageTypesOptions.push({
        label: "Broadband",
        value: EPackageType.BROADBAND,
      });
    }

    return packageTypesOptions;
  };

  return (
    <Row className={[className, "row-cols-1 row-cols-md-2 gy-3"].join(" ")}>
      <Col>
        <SelectOption
          placeholder="Select Product..."
          onChange={(val) => {
            handleChangeCircuitId([]);
            props.onChangeBroadbandId && props.onChangeBroadbandId("");
            props.onSearchInBroadbandId && props.onSearchInBroadbandId("");
            setSelectedPackageType(val.value);
          }}
          options={getPackageTypesOptions()}
          value={getPackageTypesOptions().find(
            (op) => op.value === defaultPackageType
          )}
        />
      </Col>
      {selectedPackageType !== EPackageType.BROADBAND ? (
        <Col>
          <SelectOption
            value={selectedCircuitId}
            placeholder="Select Circuit ID"
            options={circuitIdOptions}
            onChange={(val) => handleChangeCircuitId(val)}
          />
        </Col>
      ) : (
        <Col>
          <SearchBar
            placeholder="Type Broadband ID"
            onSearch={props.onSearchInBroadbandId}
            onChange={props.onChangeBroadbandId}
            shouldShowSearchIcon={shouldShowSearchIcon}
            defaultValue={defaultBroadbandId}
          />
        </Col>
      )}
    </Row>
  );
};

export default ProductAndCircuitIdSelector;
